import Cookies from "universal-cookie";

const cookie = new Cookies(); 
const Cookie = { 
    get(key) { 
        return cookie.get(key);
    },
    
    put(key, value, expires = null) {
        try{
            cookie.set(key, value, { path: '/',  expires: !expires ? new Date(Date.now()+3600000) : expires})
            return true
        } catch(e){ 
            console.log(e)
            return false
        }
    },
    remove(key) {
        cookie.remove(key, {path: "/"})
    },
    flush() {
        for (const key in cookie.getAll()) {
            if (Object.hasOwnProperty.call(cookie.getAll(), key)) {
                cookie.remove(key)
            }
        }
        return true
    }
}

export default Cookie;